import {
  downloadPresignedUrlService,
  uploadPresignedUrlService,
} from '@/services/presignedUrls';
import { PresignedUrlRequest } from '@/types/common';
import { useMutation } from '@tanstack/react-query';

export const useUploadPresignedUrl = () => {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: (data: PresignedUrlRequest) => uploadPresignedUrlService(data),
  });

  return {
    uploadPresignedUrl: mutateAsync,
    isUploadPresignedUrl: isPending,
  };
};

export const useDownloadPresignedUrl = () => {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: (data: PresignedUrlRequest) =>
      downloadPresignedUrlService(data),
  });

  return {
    downloadPresignedUrl: mutateAsync,
    isDownloadPresignedUrl: isPending,
  };
};
